<!-- File Preview Display -->
<div class="preview-display">
    <div class="preview-header">
        <span>{{data.name}}</span>
        <button type="button" (click)="closePreview()" class="close-preview">
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <iframe [src]="data.url" width="100%" width="800px" height="600px" frameborder="0"></iframe>
</div>